import BaseApi from '@/services/api/base.api'

class AuthApi extends BaseApi {
  /**
   * @description 로그인
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=%F0%9F%94%8E%20Default%20(%EC%A0%84%EC%B2%B4)#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/login
   */
  async login(
    email: string,
    password: string,
  ): Promise<ILoginInsert.ResponseItem> {
    const result: ILoginInsert.Response = await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v2/entry-artist/auth/login`,
      {
        email,
        password,
      },
    )

    return result.success
  }

  /**
   * @description 이메일 인증 코드 전송
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=11.%20%EC%9E%91%EA%B0%80%EC%9E%85%EC%A0%90#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/sendVerificationCode
   */
  async insertEmailVerificationCode(
    email: string,
  ): Promise<IAuthJoinVerifyEmailInsert.ResponseItem> {
    const result: IAuthJoinVerifyEmailInsert.Response =
      await this.app.$fetchService.post(
        `${this.artistAggregatorBaseUrl}/api/v2/entry-artist/auth/email/send-verification`,
        {
          email,
        },
      )

    return result.success
  }

  /**
   * @description 이메일 인증 코드 확인
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=11.%20%EC%9E%91%EA%B0%80%EC%9E%85%EC%A0%90#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/verifyEmailCode
   */
  async insertVerifyEmailCode(
    value: string,
    code: string,
  ): Promise<IAuthJoinVerifyEmailCodeInsert.ResponseItem> {
    const result: IAuthJoinVerifyEmailCodeInsert.Response =
      await this.app.$fetchService.post(
        `${this.artistAggregatorBaseUrl}/api/v2/entry-artist/auth/email/verify`,
        {
          value,
          code,
        },
      )

    return result.success
  }

  /**
   * @deprecated 본인인증 관련 변경으로 v3로 변경
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=11.%20%EC%9E%91%EA%B0%80%EC%9E%85%EC%A0%90#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/register
   */
  async signup(params: IAuthJoin.Request): Promise<IAuthJoin.ResponseItem> {
    const result: IAuthJoin.Response = await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v2/entry-artist/auth/register`,
      params,
    )

    return result.success
  }

  /**
   * @description 회원가입
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=%F0%9F%94%8E%20Default%20(%EC%A0%84%EC%B2%B4)#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/register
   */
  async signupV2(
    params: IAuthJoinV2.Request,
  ): Promise<IAuthJoinV2.ResponseItem> {
    const result: IAuthJoinV2.Response = await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v3/entry-artist/auth/register`,
      params,
    )

    return result.success
  }

  /**
   * @description 로그아웃
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=11.%20%EC%9E%91%EA%B0%80%EC%9E%85%EC%A0%90#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/logout
   */
  async logout(): Promise<void> {
    await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v2/entry-artist/auth/logout`,
    )
  }

  /**
   * @description 비밀번호 찾기 이메일 전송
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=11.%20%EC%9E%91%EA%B0%80%EC%9E%85%EC%A0%90#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/findPassword
   */
  async sendChangePasswordEmail(email: string): Promise<void> {
    await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v2/entry-artist/auth/password/find`,
      {
        email,
      },
    )
  }

  /**
   * @description 비밀번호 변경
   * @docs https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=11.%20%EC%9E%91%EA%B0%80%EC%9E%85%EC%A0%90#/100.%EC%9E%91%EA%B0%80%20%EC%8B%9C%EC%8A%A4%ED%85%9C%20%EC%9D%B8%EC%A6%9D/resetPassword
   */
  async changePassword(params: IAuthChangePassword.Request): Promise<void> {
    await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v2/entry-artist/auth/password/reset`,
      params,
    )
  }
}

export default AuthApi
